<template>
    <div class="pages">
        <List v-if="client_id" :DB="list" :client_id="client_id" @emit="emit"/>
        <component v-for="component in components" :is="component.component" :item="component.item" @emit="emit" />
    </div> 
</template>

<script>

import List from '../components/List.vue'
import { mapMutations } from 'vuex'
import { format } from 'date-fns';
import Alert from '../utils/Alert.js'
import WebSoc from '../utils/WebSoc.js';

export default {
    name: 'pages',
    components: {
        List,
    },
    computed: {
        client_id () { return this.$store.state.client_id }
    },
    created () {
        this.list.filter.client_id = this.client_id;  
    },
    data () {
        return {
            components: [],
            list: { 
                t: 'pages-list',
                DB: 'pages',
                storeDB: true,
                title: 'Pages',
                fields: [
                    { title: 'Page', field: 'title', class: 'td-ulb', width: 200 },
                    { title: 'Created', field: 'created', class: 'ta-r', width: 160, type: 'date', map: item => format(item.created,'dd/MM/yy HH:mm'), },
                    { title: 'Updated', field: 'update', class: 'ta-r', width: 160, order: 'asc', type: 'date', map: item => format(item.update,'dd/MM/yy HH:mm') },
                    { title: 'Views', field: 'qtyClicks', width: 120, type: 'num' },
                ],
                filter: { $and: [{ face: { $ne: 'home' } },{ face: { $ne: 'join' } } ] },
                project: {},
                onItems ( items ) {
                    console.log('items',items);
                }
            }
        } 
    },
    methods: {
        emit ( data ) {
            var field = data.field;
            switch ( data.t ) {
                case 'pages-list':
                
                    if ( data.action == 'new' ) return this.$router.push('/pagedesigner/new-page');

                    switch ( field.field ) {

                        case 'title': 
                            if ( data.e.shiftKey ) {
                                return Alert.yesno('Delete '+data.item.title+'?',yes => {
                                    if ( !yes ) return;
                                    WebSoc.SEND('delete',{ DB: 'pages', _id: data.item._id },() => console.log('deleted'));
                                })
                            }
                           
                            return this.$router.push('/pagedesigner/'+data.item._id)
                    }
            }

            console.log('what with Pages emit data',data);

        }
    }
}

</script>

<style>

</style>